var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Combobox } from '@headlessui/react';
import cn from "classnames";
var SelectAutocomplete = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(Combobox, __assign({ ref: ref }, props)));
});
SelectAutocomplete.displayName = "SelectAutocomplete";
var SelectInput = React.forwardRef(function (_a, ref) {
    var className = _a.className, leftElement = _a.leftElement, _b = _a.error, error = _b === void 0 ? false : _b, placeholder = _a.placeholder, props = __rest(_a, ["className", "leftElement", "error", "placeholder"]);
    var _c = React.useState(false), inputFocused = _c[0], setInputFocused = _c[1];
    return (_jsx(Combobox.Button, __assign({ className: cn('flex items-center justify-between border rounded overflow-hidden w-full', {
            'border-neutral-200': !error,
            'border-neutral-600': !error && inputFocused,
            'border-error-500 disabled:border-neutral-200': error,
        }) }, { children: function (_a) {
            var disabled = _a.disabled;
            return (_jsxs(_Fragment, { children: [leftElement && (_jsx("span", __assign({ className: cn('pl-3 pr-2 flex items-center justify-center', {
                            'text-error-500': error,
                            'text-neutral-300': !error && disabled,
                        }) }, { children: leftElement }))), _jsx(Combobox.Input
                    /* @ts-ignore this prop is not defined on <Combobox.Input /> but can be used because is and input */
                    , __assign({ 
                        /* @ts-ignore this prop is not defined on <Combobox.Input /> but can be used because is and input */
                        placeholder: placeholder, className: cn('w-full h-full outline-none disabled:bg-transparent', className, {
                            'px-3 py-1': !leftElement,
                            'pr-3 py-1': leftElement,
                            'placeholder:text-neutral-400 text-neutral-400': disabled && !error,
                            'placeholder:text-neutral-700': !error && !disabled,
                            'placeholder:text-error-500 text-error-500': error && !disabled,
                        }), ref: ref, onFocus: function () { return setInputFocused(true); }, onBlur: function () { return setInputFocused(false); } }, props)), _jsx("div", __assign({ className: cn('ml-2 h-full min-w-[2.5rem] max-w-[2.5rem] p-2 flex items-center justify-center border-l', {
                            'bg-neutral-200 text-neutral-400 border-neutral-200': disabled,
                            'bg-neutral-200/40': !disabled && !error,
                            'bg-error-100 bg-opacity-20 border-error-500': error && !disabled,
                            'border-neutral-600': !error && inputFocused,
                        }) }, { children: _jsx("span", __assign({ className: "font-icons-solid text-lg text-center" }, { children: "expand_more" })) }))] }));
        } })));
});
SelectInput.displayName = "Input";
var SelectOptions = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children;
    return (_jsx(Combobox.Options, { className: cn('rounded w-full shadow overflow-auto font-texts p-1 max-h-35', className), ref: ref, children: children }));
});
SelectOptions.displayName = "Options";
var SelectOption = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(Combobox.Option, __assign({ className: function (_a) {
            var active = _a.active;
            return cn('hover:bg-neutral-100 rounded p-3', className, {
                'bg-neutral-100': active,
            });
        }, ref: ref }, props)));
});
SelectOption.displayName = "Option";
SelectAutocomplete.Input = SelectInput;
SelectAutocomplete.Options = SelectOptions;
SelectAutocomplete.Option = SelectOption;
export default SelectAutocomplete;
//# sourceMappingURL=SelectAutocomplete.js.map